import React from 'react'
import { createContext } from 'use-context-selector'

import { AdminMenuUiActions } from './actions'
import { adminMenuUiStateReducer } from './reducer'
import { AdminMenuUiState, initialAdminMenuUiState } from './state'

export const AdminMenuUiStateContext = createContext<{
  state: AdminMenuUiState
  dispatch: React.Dispatch<AdminMenuUiActions>
}>({
  state: initialAdminMenuUiState,
  dispatch: () => undefined,
})

export interface AdminMenuUiStateProviderProps extends React.HTMLAttributes<HTMLDivElement> {}

export const AdminMenuUiStateProvider = ({ children }: AdminMenuUiStateProviderProps) => {
  const [state, dispatch] = React.useReducer(adminMenuUiStateReducer, initialAdminMenuUiState)

  return <AdminMenuUiStateContext.Provider value={{ state, dispatch }}>{children}</AdminMenuUiStateContext.Provider>
}
